import React, { Component } from 'react';
import moment from 'moment';

import { Body } from './Components';
import Header from './kouponi-header';
import LiveBet from './LiveBet';
import { config } from './config';

//GLOBAL TIME SETTINGS
const LIMIT_HOUR  = 7;
const NOW = moment().format('H');

let PREV = moment().subtract(1, 'days').format('YYYY-MM-DD');

if( NOW < LIMIT_HOUR ) {// more than 00:00 less than END_HOUR
  PREV  = moment().subtract(2, 'days').format('YYYY-MM-DD');
}

class Kouponi extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      clientDisabled: false
    };
  }

  setClientStatusCallback = (clientDisabled) => {
    this.setState({ clientDisabled })
  }

  render() {
    if( this.props.selectedDate === null ){
      return null;
    }

    return (
      <div>
       <table>
           <Header
             res={this.props.res}
             isStatic={this.props.isLive ? false : true}/>
          {!this.state.clientDisabled && <Body
               isExternal={this.props.isExternal}
               isStatic={this.props.isLive ? false : true}
               res={this.props.res}
               onDateChange={this.props.handleDate}
               onSelectGame={this.props.onSelectGame}
               searchSelectedId={this.props.searchSelectedId}
               soundEnabled={this.props.soundEnabled}
               dateControls={this.props.dateControls}
               date={this.props.selectedDate}
               clientId={this.props.clientId}
               productId={this.props.productId}
               clientDisabled={this.state.clientDisabled}
               setClientStatusCallback={this.setClientStatusCallback}
               showFilter={this.props.showFilter}
               setTextLink={this.props.setTextLink}
             />
           }
         </table>
        {this.state.clientDisabled && <div className="cors-message">{config.corsMessage.el}</div>}

        {!this.props.isExternal && <LiveBet
          showFilter={this.props.showFilter}/>}

        {!this.state.clientDisabled && this.props.isLive && this.props.showFilter === 'SHOW_ALL' &&
          <div style={{ display: 'inline-block', width: '100%' }}>
            {/*<h2 className="r-kouponi-h2">ΑΠΟΤΕΛΕΣΜΑΤΑ ΠΑΜΕ ΣΤΟΙΧΗΜΑ</h2>*/}
            <h2 className="date_header r-kouponi-h2">ΑΠΟΤΕΛΕΣΜΑΤΑ ΠΑΜΕ ΣΤΟΙΧΗΜΑ</h2>
            <table>
              <Header
                res={this.props.res}
                isStatic={true}/>
              <Body
                res={this.props.res}
                noControls={true}
                isStatic={true}
                date={PREV}
                clientDisabled={this.state.clientDisabled}
                setClientStatusCallback={this.setClientStatusCallback}
                clientId={this.props.clientId}
                setTextLink={this.props.setTextLink}
                productId={this.props.productId}
              />
            </table>
          </div>}
      </div>
    )
  }
};

export default Kouponi;


// WEBPACK FOOTER //
// ./src/Kouponi.js